import {faFilePdf, faSpinner} from '@fortawesome/fontawesome-pro-regular';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React from 'react';
import {usePdfExport, generatePdfData} from '../../../../hooks/usePdfExport';

export const PdfLink = ({rowData, column, styleSheet}) => {
  let exportPdfData = generatePdfData(rowData);
  exportPdfData.benefitType = `${exportPdfData.benefitType} Benefit`;

  // Using the usePdfExport hook to generate the PDF
  const {isGenerating, handlePdfExport} = usePdfExport({
    templateId: column.meta.templateId,
    templateName: column.meta.templateName,
    data: {data: [exportPdfData]},
    namePrefix: 'pdf-link',
    id: rowData.id
  });

  return (
    isGenerating ? (
      <FontAwesomeIcon icon={faSpinner} spin size="lg" />
    ) : (
      <a
        id={rowData.id}
        onClick={handlePdfExport}
        data-testid={`pdf-link-${rowData.id}`}
        style={{cursor: 'pointer'}}
        title={column.meta.title}
      >
        <FontAwesomeIcon icon={faFilePdf} size={'2x'} />
      </a>
    )
  );
};
